import { List } from "@/components/list/List";
import { DataTableQueryContextProvider } from "@/components/data-table/DataTableQueryContext";
import { CollapsibleSection } from "@/components/CollapsibleSection";
import { useTranslation } from "react-i18next";
import { useContractorAssignmentsList } from "../hooks/useContractorAssignmentsList";
import { ContractorPlannedHoursService } from "../contractorPlannedHoursService";
import { readContractorPlannedHours } from "@/schemas/contractorPlannedHours";
import { useState } from "react";

interface ContractorPlannedHoursListProps {
  contractorId: string;
}

export const ContractorPlannedHoursList = ({
  contractorId,
}: ContractorPlannedHoursListProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const { query, filteredOptions } = useContractorAssignmentsList({
    name: "contractorPlannedHours",
    service: ContractorPlannedHoursService,
    contractorId,
    enabled: isOpen,
    sorting: [{ id: "period", desc: false }],
  });

  return (
    <CollapsibleSection
      title={t("contractors.plannedHours.title")}
      description={t("contractors.plannedHours.description")}
      defaultOpen={false}
      scrollIntoViewOnOpen
      onOpenChange={setIsOpen}
    >
      <List
        schema={readContractorPlannedHours}
        name="contractorPlannedHours"
        translationKey="contractorPlannedHours"
        query={query}
        options={filteredOptions}
      >
        <List.Menubar>
          <List.Menubar.Columns />
          <List.Menubar.Reset />
        </List.Menubar>
        <DataTableQueryContextProvider value={{ query }}>
          <List.Content isInDialog>
            <List.Status />
          </List.Content>
        </DataTableQueryContextProvider>
      </List>
    </CollapsibleSection>
  );
};
